import { Component, ElementRef, Input, OnInit, QueryList, ViewChildren } from '@angular/core';
import { HomeSlider, ProductSlider } from '../../../shared/data/slider';
import { Product, EcomProd, HomepageModule } from '../../../shared/classes/product';
import { ProductService } from '../../../shared/services/product.service';
import { response } from 'express';
import { HomeModule } from '../../home.module';
import { BehaviorSubject } from 'rxjs';
import { NavigationStart, Router } from '@angular/router'
import { ExternalService } from 'src/app/shared/services/external.service';
import { MyService } from 'src/app/shared/services/myservice';
import { Console } from 'node:console';


@Component({
  selector: 'app-fashion-one',
  templateUrl: './fashion-one.component.html',
  styleUrls: ['./fashion-one.component.scss']
})
export class FashionOneComponent implements OnInit {
  public productCollections: any[] = [];
  public active;
  public ecomproducts: EcomProd[] = [];
  public Homeproducts: EcomProd[] = [];
  public HomePage: HomepageModule[] = [];
  public reels = [];
  public collections = []
  public reelsvideo: any = []
  public sliders = []
  public BackGround = []
  public footer = []
  public Small_Adv = []
  public Small_AdvImg: string
  public logoLive = []
  public prodindex: any
  public Category: any = [];
  public Categorys: any = [];
  public catId = 0
  public someCondition
  name: string = ''
  loaderline: boolean = false
  public ProductSliderConfig: any = ProductSlider;
  constructor(public productService: ProductService, private router: Router, private externalservice: ExternalService, private myService: MyService) {
    localStorage.setItem('mypg', '0');
    this.myService._pageId.next(0);
    localStorage.removeItem('myApp_Search');
    this.externalservice.setShowHeader(true);
    this.productService.Categories.subscribe(Cat => {
      const data = Cat["data"]
      this.Categorys = data
      this.someCondition = this.Categorys[0].id
      this.catId = 0
      this.myService._catID.next(this.catId);
    });


  }
  @ViewChildren('videoPlayer') videoRefs!: QueryList<ElementRef<HTMLVideoElement>>;


  ngOnInit(): void {
    this.gethomedata()
    this.getReelsVideo()
    // this.sendreelsview(this.reelsvideo[this.id])

  }
  // togglePlay(video: HTMLVideoElement) {
  //   if (video.paused) {
  //     video.play();
  //   } else {
  //     video.pause();
  //   }
  // }


  // getreelsvideo(){
  //   this.productService.Reelsvideo.subscribe(x =>{
  //   this.reels =x
  //   })
  // }

  ReelsVid: any = []
  getReelsVideo() {
    this.productService.Videos.subscribe(x => {
      this.ReelsVid = x
      // console.log(this.ReelsVid)
      this.reelsvideo = this.ReelsVid["reels"];
      // console.log(this.reelsvideo)
      this.reelsvideo.forEach((item) => {
        const itemName = JSON.parse(item.description);
        // console.log(itemName)
        item.Pname = itemName.name; // Directly assign the string
        item.Pdesc = '';        // Set empty or use default value if needed
        item.f1_color = itemName.f2_color;     // Or fetch from somewhere else if needed
        item.f2_color = '';
        item.categoryId = null;
        item.id = item.id;// Optional
      });
      // console.log(this.reelsvideo)
    })
  }

  id: number
  reelsview: any = []
  sendreelsview(id: number) {
    // console.log(id);
    const payload = { id: id };

    this.productService.reelsview(payload).subscribe(x => {
      this.reelsview = x;
      // console.log(this.reelsview);

      this.reelsvideo.forEach(video => {
        if (video.id === id) {
          video.views = this.reelsview.views;  // Update views
        }
      });

      // console.log(this.reelsvideo);
    });
  }

  gethomedata() {
    this.LoadTime()
    this.productService.Homepageprod.subscribe(x => {
      setTimeout(() => {
        document.getElementById('preloaderfas').style.display = 'none'
      }, 1300);
      this.HomePage = x
      // console.log(this.HomePage)
      this.collections = this.HomePage["ads"]
      this.collections.forEach((item) => {
        const itemName = JSON.parse(item.name);
        item.Pname = itemName.name
        item.Pdesc = itemName.desc
        item.f1_color = itemName.f1_color
        item.f2_color = itemName.f2_color
        item.categoryId = itemName.categoryId
      });



      // console.log(this.collections)
      this.sliders = this.HomePage["banner"]
      this.sliders.forEach((item) => {
        const itemName = JSON.parse(item.name);
        item.Pname = itemName.name
        item.Pdesc = itemName.desc
        item.f1_color = itemName.f1_color
        item.f2_color = itemName.f2_color
      });
      this.Homeproducts = this.HomePage["premiumproducts"]
      this.Homeproducts.forEach(ele => {
        ele.preDef = JSON.parse(ele.qty_price)
      })
      this.BackGround = this.HomePage["background"]
      this.BackGround.forEach((item) => {
        const itemName = JSON.parse(item.name);
        item.Pyear = itemName.year
        item.Pname = itemName.name
        item.Pdesc = itemName.desc
        item.f1_color = itemName.f1_color
        item.f2_color = itemName.f2_color
      });
      this.footer = this.HomePage["header_footer"]
      this.footer.forEach((item) => {
        const itemName = JSON.parse(item.footer_content_1);
        item.F1desc = itemName.desc
        item.F2title = itemName.title
        const itemName1 = JSON.parse(item.footer_content_2);
        item.Lable1 = itemName1.title
        item.Lable2 = itemName1.lable1
        item.Lable3 = itemName1.lable2
        item.Lable4 = itemName1.lable3
      });
      this.Small_Adv = this.HomePage["small_Advert"]
      this.Small_AdvImg = this.Small_Adv[0].imgurl
      this.myService.SmallAdvImg.next(this.Small_Adv[0].imgurl)
    })
  }

  routecollect(item) {
    this.myService._catID.next(item);
    // console.log(this.router.url)
  }
  // Product Tab collection
  // getCollectionProducts(collection) {
  //   return this.products.filter((item) => {
  //     if (item.collection.find(i => i === collection)) {
  //       return item
  //     }
  //   })
  // }

  // ECom Product Tab collection

  // scrollNext(container: HTMLElement): void {
  //   const reelWidth = container.offsetWidth / 4; // scroll by 1 reel width (¼th)
  //   container.scrollBy({ left: reelWidth, behavior: 'smooth' });
  // }


  getCollectionEComProducts(collection) {
    return this.ecomproducts.filter((item) => {
      // if (item.collection.find(i => i === collection)) {
      return item
      // }
    })
  }

  // isVideo(url: string): boolean {
  //   return url?.toLowerCase().endsWith('.mp4') ||
  //     url.toLowerCase().endsWith('.webm') ||
  //     url.toLowerCase().endsWith('.ogg');
  // }

  // playVideo(event: Event) {
  //   const target = event.currentTarget as HTMLElement;
  //   const video = target.querySelector('video');
  //   if (video) {
  //     (video as HTMLVideoElement).play();
  //   }
  // }


  playVideoOnHover(event: MouseEvent) {
    const video = (event.target as HTMLElement).querySelector('video') as HTMLVideoElement;
    if (video) {
      video.play();
    }
  }

  pauseVideoOnLeave(event: MouseEvent) {
    const video = (event.target as HTMLElement).querySelector('video') as HTMLVideoElement;
    if (video) {
      video.pause();
    }
  }
  activeVideoUrl: string | null = null;
  showPopup = false;




  LoaderStyle = `
  <style>
  #preloader {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    backdrop-filter: blur(5px);
    z-index: 1000;
  }
  
  #loader {
    display: block;
    position: relative;
    left: 50%;
    top: 50%;
    width: 50px;
    height: 50px;
    margin: -50px 0 0 -30px;
    backdrop-filter: blur(2px);  
  }


  .loaderzig {
    display: flex;
    align-items: center;
  }
  .loader__part--1 {
    animation: opacity .3s linear forwards, anim-1 .5s cubic-bezier(.80, 0, .60, 1) infinite alternate;
    animation-delay: .3s;
  }
  
  .loader__part--2 {
    animation: opacity .3s linear forwards, anim-2 .5s cubic-bezier(.80, 0, .60, 1) infinite alternate;
    animation-delay: .6s;
  }
  
  .loader__part--3 {
    animation: opacity .3s linear forwards, anim-3 .5s cubic-bezier(.80, 0, .60, 1) infinite alternate;
    animation-delay: .9s;
  }
  
  @keyframes anim-1 {
    0% {
        height: 5px;
    }
  
    100% {
        height: 35px;
    }
  }
  
  @keyframes anim-2 {
    0% {
        height: 5px;
    }
  
    100% {
        height: 38px;
    }
  }
  
  @keyframes anim-3 {
    0% {
        height: 5px;
    }
  
    100% {
        height: 41px;
    }
  }
  
  @keyframes opacity {
    0% {
        opacity: 0;
    }
  
    100% {
        opacity: 1;
    }
  }
  
  .loader__part {
    background: red;
    width: 5px;
    border-radius: 3px;
    margin: 0 5px;
    opacity: 0;
  }
    
  </style>`


  LoadTime() {
    var printtemplate = `
    <div style="display: none;" id="preloader">   
    <div id="loader">
      <div class="loaderzig">
        <div class="loader__part loader__part--1"></div>
        <div class="loader__part loader__part--2"></div>
        <div class="loader__part loader__part--3"></div>
      </div>
    </div>
  </div>`
    printtemplate += this.LoaderStyle
  }
  popupVisible = false;
  popupVideoUrl: string = '';
  openPopup(data: any): void {
    // console.log(data)
    this.activeVideoUrl = data.videourl;
    this.showPopup = true;
    this.sendreelsview(data.id);

    // Pause all background videos
    const backgroundVideos = document.querySelectorAll('video.reel-media') as NodeListOf<HTMLVideoElement>;
    backgroundVideos.forEach(video => video.pause());

    // Optional: load popup video after slight delay
    setTimeout(() => {
      const popupVideo = document.querySelector('.popup-reel-media') as HTMLVideoElement;
      if (popupVideo) {
        popupVideo.load();
        popupVideo.play();
      }
    }, 100);
  }
  closePopup(): void {
    this.showPopup = false;
    this.activeVideoUrl = '';
    // this.sendreelsview(this.id);
  }




  scrollNext() {
    const first = this.reelsvideo.shift();
    if (first) {
      this.reelsvideo.push(first);
    }
  }

  scrollPrev() {
    const last = this.reelsvideo.pop();
    if (last) {
      this.reelsvideo.unshift(last);
    }
  }



  playVideo(video: HTMLVideoElement, playBtn: HTMLElement) {
    video.play();
    if (playBtn) {
      playBtn.style.display = 'none';
    }
  }

  pauseVideo(video: HTMLVideoElement, playBtn: HTMLElement) {
    video.pause();
    if (playBtn) {
      playBtn.style.display = 'block';
    }
  }

  togglePlay(video: HTMLVideoElement, playBtn: HTMLElement) {
    if (video.paused) {
      video.play();
      if (playBtn) playBtn.style.display = 'none';
    } else {
      video.pause();
      if (playBtn) playBtn.style.display = 'block';
    }
  }



  toggleMute(video: HTMLVideoElement, event: Event) {
    event.stopPropagation(); // prevents toggling play
    video.muted = !video.muted;
  }


  // shareReel(url: string, event: Event) {
  //   event.stopPropagation(); // prevents toggling play
  //   if (navigator.share) {
  //     navigator.share({
  //       title: 'Check out this reel!',
  //       url: url
  //     }).catch(err => console.error('Sharing failed', err));
  //   } else {
  //     alert('Sharing not supported on this browser.');
  //   }

  // }

  shareReel(data: any, event: Event) {
    event.stopPropagation(); // prevent toggling play

    // Call the share tracking API
    this.sendreelsshare(data.id);

    if (navigator.share) {
      navigator.share({
        title: 'Check out this reel!',
        url: data.thumbnail
      }).catch(err => console.error('Sharing failed', err));
    } else {
      // Fallback options: WhatsApp, Copy Link, etc.
      const encodedURL = encodeURIComponent(data.thumbnail);

      // Example: Share via WhatsApp
      const whatsappURL = `https://wa.me/?text=${encodedURL}`;
      window.open(whatsappURL, '_blank');

      // Example: Copy to clipboard
      // navigator.clipboard.writeText(data.videourl).then(() => {
      //   alert('Link copied to clipboard!');
      // });

      // You can show a custom popup/modal for user to choose their preferred method
    }
  }



  sendreelsshare(id) {
    // console.log(id);
    const payload = { id: id };

    this.productService.reelsshare(payload).subscribe(x => {
      this.reelsview = x;
      // console.log(this.reelsview);

      this.reelsvideo.forEach(video => {
        if (video.id === id) {
          video.views = this.reelsview.views;  // Update views
        }
      });

      // console.log(this.reelsvideo);
    });
  }





  reelsIdvideo: any = []
  ReelsVidByID: any = []
  getReelsVideobyId(id) {
    this.productService.GetreelId(id)
    this.productService.reelvideobyId.subscribe(x => {
      this.ReelsVidByID = x
      // console.log(this.ReelsVidByID)
      this.reelsIdvideo = this.ReelsVidByID["video"];
      // console.log(this.reelsIdvideo)
      this.activeVideoUrl = this.reelsIdvideo[0].videourl;
      this.showPopup = true;
      this.sendreelsview(this.reelsIdvideo[0].id);

      // Pause all background videos
      const backgroundVideos = document.querySelectorAll('video.reel-media') as NodeListOf<HTMLVideoElement>;
      backgroundVideos.forEach(video => video.pause());

      // Optional: load popup video after slight delay
      setTimeout(() => {
        const popupVideo = document.querySelector('.popup-reel-media') as HTMLVideoElement;
        if (popupVideo) {
          popupVideo.load();
          popupVideo.play();
        }
      }, 100);
    })
  }



}
